// extracted by mini-css-extract-plugin
module.exports = {"Stat_label":"Stat_Stat_label_2n2f1","Stat_value":"Stat_Stat_value_-yIy6"};